import React from 'react';
import clsx from 'clsx';
import makeStyles from '@mui/styles/makeStyles';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';

import logo from '../../../static/etiq_logo_white.svg';
import account from '../../../static/sidebar/documents.svg';
import { isAuthenticated } from '../../../utils/axiosApi';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  wrapperImgLogo: {
    textAlign: 'center',
    margin: theme.spacing(2),
  },
  imgLogo: {
    width: 50,
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  img: {
    width: 24,
    height: 24,
  },
  list: {
    width: 265,
    height: '100%',
    background: '#32325d',
  },
  listItemText: {
    color: '#ffffff',
    '&:hover': {
      color: '#a0a8ff',
    },
  },
  fullList: {
    width: 'auto',
  },
}));

export default function TemporaryDrawer(props) {
  const { t } = useTranslation('home');
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const { setModalOpen, setModalState } = props;
  const toggleDrawer = (status) => (event) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }
    setOpen(status);
  };

  const list = () => (
    <div
      className={clsx(classes.list)}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <div className={classes.wrapperImgLogo}>
        <Link
          style={{ textDecoration: 'none' }}
          component={RouterLink}
          to="/"
          color="inherit"
        >
          <img className={classes.imgLogo} src={logo} alt={'logo'} />
        </Link>
      </div>
      {isAuthenticated() ? (
        <List>
          <Link
            style={{ textDecoration: 'none' }}
            component={RouterLink}
            to="/account/"
            color="inherit"
          >
            <ListItem button key="home">
              <ListItemIcon>
                <img
                  className={classes.img}
                  src={account}
                  alt={'account'}
                />
              </ListItemIcon>
              <ListItemText
                className={classes.listItemText}
                primary={
                  props.asPro ? t('login_pro') : t('login_classic')
                }
              />
            </ListItem>
          </Link>
        </List>
      ) : (
        <List>
          <ListItem button key="home">
            <ListItemText
              className={classes.listItemText}
              onClick={() => {
                setModalState('particulier');
                setModalOpen(true);
              }}
              primary={t('login_classic')}
            />
          </ListItem>
          <ListItem button key="home">
            <ListItemText
              className={classes.listItemText}
              onClick={() => {
                setModalState('professionnel');
                setModalOpen(true);
              }}
              primary={t('login_pro')}
            />
          </ListItem>
        </List>
      )}
    </div>
  );

  return (
    <React.Fragment>
      <IconButton
        edge="start"
        aria-label="menu"
        onClick={toggleDrawer(true)}
        size="large"
        sx={{ color: '#fff' }}
      >
        <MenuIcon />
      </IconButton>
      <Drawer open={open} onClose={toggleDrawer(false)}>
        {list()}
      </Drawer>
    </React.Fragment>
  );
}
